import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { UserService, HelperService } from "@mypxplat/xplat/core";

import { FeatureUpdatesBaseComponent } from "@mypxplat/xplat/features";
import { FirebaseService } from "@mypxplat/xplat/web/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { take } from "rxjs/operators";
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-feature-updates",
  templateUrl: "feature-updates.component.html",
  standalone: false,
  styles: [
    `
      .image-only-announcement {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
      }
      .image-only-close {
        position: absolute;
        top: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        border: none;
        color: white;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 16px;
        z-index: 1;
      }
      .image-only-close:hover {
        background: rgba(0, 0, 0, 0.8);
      }
      .image-only-img {
        max-width: 1000px;
        width: 100%;
        border-radius: 8px;
      }
    `,
  ],
})
export class FeatureUpdatesComponent extends FeatureUpdatesBaseComponent {
  @Input() features: Array<any>;
  @Input() showingAll: boolean;
  public displayedFeature: any;
  public selectedIndex = 0;
  public loading = false;
  public selectedAnnouncement: any;
  public isCurrentImageOnly: boolean = false;
  public sanitizedDescription: string = "";
  public selectedAnnouncementDate: Date;

  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public db: AngularFirestore,
    public fbService: FirebaseService,
    public helperService: HelperService
  ) {
    super(userService);
  }

  ngOnInit() {
    if (this.showingAll) {
      this.loading = true;
      this.fbService
        .collection("sphere_announcements")
        .ref.where("date", "<=", new Date())
        .get()
        .then((result: any) => {
          this.loading = false;
          this.features = [];
          result.docs.forEach((doc) => {
            let data = doc.data();
            const passesSubscription = this.passesSubscriptionFilter(data);
            if (passesSubscription && (!data.audience || data.audience.includes("web"))) {
              this.features.push(doc.data());
            }
          });
          this.sort(true);
        })
        .catch(() => {});
    } else {
      this.sort();
      this.updateImageOnly();
      this.markSeen();
    }
  }

  sort(reverse?) {
    this.features.sort((a, b) => {
      if (a.date.toDate() >= b.date.toDate()) {
        return reverse ? -1 : 1;
      } else {
        return reverse ? 1 : -1;
      }
    });
  }

  next() {
    this.selectedIndex++;
    this.updateImageOnly();
    if (!this.showingAll) this.markSeen();
  }

  paginate = (direction: string) => {
    if (direction === "next") {
      this.next();
    } else if (direction === "previous" && this.selectedIndex > 0) {
      this.selectedIndex--;
      this.updateImageOnly();
    }
  };

  selectAnnouncement(ann) {
    this.selectedAnnouncement = ann;
    this.selectedAnnouncementDate = ann?.date?.toDate();
    this.sanitizedDescription = ann?.description?.en ? this.helperService.sanitizeQuillHtml(ann.description.en) : "";
  }

  markSeen() {
    this.fbService.doc("user_metadata/" + this.user.id).set(
      {
        sphere_announcements: {
          [this.features[this.selectedIndex].string_id]: true,
        },
      },
      { merge: true }
    );
  }

  private updateImageOnly() {
    const f = this.features?.[this.selectedIndex];
    this.isCurrentImageOnly = !!(f?.image_url && !f?.description?.en);
    this.sanitizedDescription = f?.description?.en ? this.helperService.sanitizeQuillHtml(f.description.en) : "";
  }

  private passesSubscriptionFilter(announcement): boolean {
    const filter = announcement.subscription_filter;
    if (filter === "members_only") return !!this.userService.user.active_subscription;
    if (filter === "non_members_only") return !this.userService.user.active_subscription;
    if (!filter && announcement.members_only) return !!this.userService.user.active_subscription;
    return true;
  }
}
